import { MenuContext } from "../../contexts/MenuContext";
import { getTheme } from "../../utils/Storage";
import { useContext, useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import ChartPreloader from "../Preloader/ChartPreloader";

export default function BarChart({ data }) {
    const menuCtx = useContext(MenuContext);
    const [loading, setLoading] = useState(true);
    const [t] = useTranslation();

    const [chartData, setChartData] = useState(data);
    useEffect(() => {
        if (getTheme() === "dark") {
            let dataTemp = chartData;
            dataTemp.options.chart.background = "transparent";
            dataTemp.options.title.text = t(dataTemp.options.title.text);
            dataTemp.options.title.style = {
                fontSize: "20px",
                fontWeight: "medium",
                fontFamily: "Outfit",
                color: "#fafafa",
            };
            dataTemp.options.theme = {
                mode: "dark",
            };
            setChartData(dataTemp);
            setLoading(true);
        } else {
            let dataTemp = chartData;
            dataTemp.options.title.text = t(dataTemp.options.title.text);
            dataTemp.options.title.style = {
                fontSize: "20px",
                fontWeight: "medium",
                fontFamily: "Outfit",
                color: "#111112",
            };
            dataTemp.options.theme = {
                mode: "light",
            };
            setChartData(dataTemp);
            setLoading(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [menuCtx.dark]);

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 300);
    }, [loading]);

    return !loading ? (
        <Chart
            options={chartData.options}
            series={chartData.series}
            height={350}
            type="bar"
        />
    ) : (
        <ChartPreloader />
    );
}
